import React, { Component } from 'react'
import Button from "reactstrap/es/Button"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { listLocal } from '../../helpers/filtersTable'
import { actionChangeShippingCarrier } from "../../../services/api/apiReGenerateLabel"
import Promise from "bluebird"
import { SHIPPING_LEVELS, CARRIERS_SUPPORT_SHIPPING_LEVELS, SHIPPING_PLANS } from "../../../configs/config"
import { getListShippingCarrierApp } from '../../../services/api/apiFFM'
import { Select, Input, Checkbox } from 'antd'
import { getLocalData } from '../../../services/StorageServices'

class BulkChangeShippingCarrierModal extends Component {
    state = {
        shippingCarrier: '',
        statistics: {
            pending: 0,
            inProduction: 0,
            cancelled: 0,
            onHold: 0,
            packaged: 0,
            labelled: 0,
            cancelShip: 0,
            falseDesign: 0,
            manualPackage: 0
        },
        startGen: false,
        itemsSuccess: [],
        itemError: [],
        itemLoading: '',
        listShippingCarrier: [],
        allShippingCarrier: [],
        originalCarrier: '',
        shippingLevel: '',
        shippingPlan: '',
    }

    componentDidMount() {
        this._handleStatitics()
        this._fetchFiltersShippingCarrier()
    }

    _fetchFiltersShippingCarrier = async (payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrierApp(newPayload)
            const { data, success, message } = { ...res }
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length > 0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            this.setState({
                listShippingCarrier: shippingCarriers.filter(i => !!i.is_active) || [],
                allShippingCarrier: shippingCarriers || [],
            })

        } catch (error) {
            alert(error.message)
        }
    }

    _handleStatitics = () => {
        const { selectedItems, items } = this.props
        const _itemsSelected = items.filter(itemSelected => selectedItems.includes(itemSelected._id))
        this.setState({
            statistics: {
                ...this.state.statistics,
                pending: _itemsSelected.filter(itemP => itemP.production_status === 'pending').length,
                inProduction: _itemsSelected.filter(itemP => itemP.production_status === 'in_production').length,
                cancelled: _itemsSelected.filter(itemP => itemP.production_status === 'cancelled').length,
                onHold: _itemsSelected.filter(itemP => itemP.production_status === 'on-hold').length,
                packaged: _itemsSelected.filter(itemP => itemP.production_status === 'packaged').length,
                labelled: _itemsSelected.filter(itemP => itemP.production_status === 'labelled').length,
                cancelShip: _itemsSelected.filter(itemP => itemP.production_status === 'cancel-ship').length,
                falseDesign: _itemsSelected.filter(itemP => itemP.production_status === 'false_design').length,
                manualPackage: _itemsSelected.filter(itemP => itemP.production_status === 'manual-package').length,
            }
        })
    }

    _handleChangeSelect = (prop) => (e) => {
        if (['shippingCarrier', 'shippingLevel', 'shippingPlan'].includes(prop)) {
            this.setState({
                [prop]: e,
            })
            return
        }
        const { value } = e.target

        this.setState({
            [prop]: value,
        }, () => {
            //this._handleSubmit()
        })
    }

    _handleSubmit = async () => {
        const { shippingCarrier, shippingLevel, originalCarrier, shippingPlan } = this.state
        const { selectedItems, items, force, } = this.props
        const _itemsSelected = items.filter(itemSelected => selectedItems.includes(itemSelected._id))
        const total = this.state.itemsSuccess.length > 0 ? (_itemsSelected.length + this.state.itemsSuccess.length) : _itemsSelected.length

        this.setState({
            startGen: true
        })

        await Promise.each(_itemsSelected, async item => {
            this.setState({
                itemLoading: item._id
            })

            try {
                const payload = {
                    barcodeNumber: item.barcodeNumber,
                    shipping_carrier: shippingCarrier,
                    shipping_level: shippingLevel,
                }

                if (shippingCarrier === '') delete payload['shipping_carrier']
                if (shippingLevel) payload.shipping_level = shippingLevel
                if (force) {
                    delete payload['shipping_carrier']
                    payload.forceLabelDetail = {
                        shipping_carrier: shippingCarrier,
                        original_carrier: originalCarrier,
                    }
                }
                if (!!shippingPlan) payload.shipping_plan = shippingPlan

                const { data: response } = await actionChangeShippingCarrier(payload)
                const { success, message } = response

                let { itemError, itemsSuccess } = this.state

                if (success) {

                    itemsSuccess.push(item._id)

                    this.setState({
                        itemsSuccess: itemsSuccess,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                } else {
                    itemError.push({
                        _id: item._id,
                        message: message
                    })

                    this.setState({
                        itemError: itemError,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                }
            } catch (e) {
                let { itemError, itemsSuccess } = this.state

                let errorMessage = 'Có lỗi xảy ra'

                // API trả về response (403, 401, 500…)
                if (e.response) {
                    const { status, data } = e.response

                    if (status === 403) {
                        errorMessage = data && data.message ? data.message : 'Bạn không có quyền thực hiện thao tác này'
                    } else {
                        errorMessage = data && data.message ? data.message : `Lỗi server (${status})`
                    }
                } else if (e.request) { //Không có response (timeout, network)
                    errorMessage = 'Không thể kết nối tới server'
                } else {
                    errorMessage = e.message
                }

                itemError.push({
                    _id: item._id,
                    message: errorMessage
                })

                this.setState({
                    itemError,
                    itemLoading:
                        (itemError.length + itemsSuccess.length) === total ? '' : item._id
                })
            }
        })
    }

    _showMessage = (itemError, itemsSuccess, _id) => {
        if (itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => _id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Change shipping carrier success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    _handleChangeInput = (e) => {
        this.setState({ originalCarrier: e.target.value })
    }

    _handleChangeCheckBox = (e) => {
        const { handleChangeForce } = this.props
        const checked = e.target.checked
        if (!checked) this.setState({ originalCarrier: '' })
        handleChangeForce(e)
    }

    render() {
        const { shippingCarrier, shippingLevel, statistics, startGen, itemLoading, itemsSuccess, itemError, listShippingCarrier, allShippingCarrier, originalCarrier, shippingPlan } = this.state
        const { isOpen, handleToggleModal, selectedItems, items, force } = this.props
        const userRoles = !!getLocalData('roles') && getLocalData('roles').length > 0 ? getLocalData('roles').map(i => i.name) : []
        const adminPermission = !!userRoles.length && userRoles.includes('fac_admin') || userRoles.includes('fac_admin')
        const _itemsSelected = items.filter(itemSelected => selectedItems.includes(itemSelected._id))
        const { pending, inProduction, cancel, onHold, packaged, labelled, cancelShip, falseDesign, manualPackage } = statistics
        const shippingCarrierOptions = !!listShippingCarrier && listShippingCarrier.length > 0 ? listShippingCarrier.map(i => ({
            value: i.slug,
            name: i.name,
            is_active: i.is_active,
        })) : []
        const { Option } = Select
        const disableBtnChange = force && !originalCarrier

        return (
            <Modal isOpen={isOpen} className="BulkChangeStatus"
            >
                <ModalHeader>
                    Change shipping carrier
                </ModalHeader>
                <ModalBody>
                    <div className="selectStatus mb-3 row">
                        <label className="col-sm-3 col-form-label">Shipping carrier</label>
                        <div className="col-sm-9">
                            <Select
                                value={shippingCarrier}
                                style={{ width: '100%' }}
                                showSearch
                                onChange={this._handleChangeSelect('shippingCarrier')}
                                onSearch={(value) => {
                                    if (value) {
                                        const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase()))
                                        this.setState({ listShippingCarrier: newList })
                                    } else {
                                        this.setState({ listShippingCarrier: allShippingCarrier.filter(i => !!i.is_active) || [] })
                                    }
                                }}
                                onBlur={() => this.setState({ listShippingCarrier: allShippingCarrier.filter(i => !!i.is_active) })}
                                filterOption={(input, option) => {
                                    return option.children.toLowerCase().includes(input.toLowerCase())
                                }}
                            >
                                <Option value="" style={{ color: '#333' }}>Default</Option>
                                {!!shippingCarrierOptions && shippingCarrierOptions.length > 0 && shippingCarrierOptions.map((itemShipping, index) => {
                                    return (
                                        <Option key={index} value={itemShipping.value} style={!itemShipping.is_active ? {} : { color: '#333' }}>{itemShipping.name}</Option>
                                    )
                                })}
                                <Option value="other" style={{ color: '#333' }}>Other</Option>
                            </Select>
                        </div>
                    </div>
                    {force &&
                        <div className="selectStatus mb-3 row">
                            <label className="col-sm-3 col-form-label">Original carrier <span className='text-danger'>*</span></label>
                            <div className="col-sm-9">
                                <Input
                                    placeholder='Input Original carrier...'
                                    value={originalCarrier || ''}
                                    onChange={this._handleChangeInput}
                                    allowClear
                                />
                            </div>
                        </div>
                    }
                    {
                        CARRIERS_SUPPORT_SHIPPING_LEVELS.includes(shippingCarrier) &&
                        <div className="selectStatus mb-3 row">
                            <label className="col-sm-3 col-form-label">Shipping level</label>
                            <div className="col-sm-9">
                                <Select
                                    value={shippingLevel || []}
                                    style={{ width: '100%' }}
                                    onChange={this._handleChangeSelect('shippingLevel')}
                                    placeholder='Select shipping level'
                                    allowClear
                                    showSearch
                                    filterOption={(input, option) => {
                                        return option.children.toLowerCase().includes(input.toLowerCase())
                                    }}
                                >
                                    {SHIPPING_LEVELS.map((itemShipping, index) => {
                                        return (
                                            <Option key={index} value={itemShipping.value}>{itemShipping.name}</Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </div>
                    }
                    <div className="selectStatus mb-3 row">
                        <label className="col-sm-3 col-form-label">Shipping plan</label>
                        <div className="col-sm-9">
                            <Select
                                value={shippingPlan || []}
                                style={{ width: '100%' }}
                                onChange={this._handleChangeSelect('shippingPlan')}
                                placeholder='Select shipping plan'
                                allowClear
                                showSearch
                                filterOption={(input, option) => {
                                    return option.children.toLowerCase().includes(input.toLowerCase())
                                }}
                            >
                                {SHIPPING_PLANS.map((iSP, index) => {
                                    return (
                                        <Option key={index} value={iSP.value}>{iSP.name}</Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </div>
                    {!startGen ? (
                        <div>
                            <div className="statitics mb-3 p-3">
                                <div className="row">
                                    <div className="col-sm-6"><label>Pending:</label> {pending}</div>
                                    <div className="col-sm-6"><label>Labelled:</label> {labelled}</div>
                                    <div className="col-sm-6"><label>In production:</label> {inProduction}</div>
                                    <div className="col-sm-6"><label>Cancel ship:</label> {cancelShip}</div>
                                    <div className="col-sm-6"><label>Cancel:</label> {cancel}</div>
                                    <div className="col-sm-6"><label>False design:</label> {falseDesign}</div>
                                    <div className="col-sm-6"><label>On hold:</label> {onHold}</div>
                                    <div className="col-sm-6"><label>Manual Package:</label> {manualPackage}</div>
                                    <div className="col-sm-6"><label>Packaged:</label> {packaged}</div>
                                </div>
                            </div>
                            <div className="confirm mb-3">
                                Are you sure want to change shipping carrier
                                for <strong>{selectedItems.length}</strong> {selectedItems.length === 1 ? 'order' : 'orders'} selected?
                                <i className="d-block">(Packaged, labelled status will change to In production
                                    status)</i>
                            </div>
                        </div>
                    ) : (
                        <div className="ListGenLabels">
                            {_itemsSelected.length > 0 && (
                                _itemsSelected.map(item => {
                                    return (
                                        <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                            <div className="IconStatus mr-2">
                                                {itemsSuccess.includes(item._id) && (
                                                    <i className="icon-check text-success" />
                                                )}
                                                {
                                                    (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) && (
                                                        <i className="icon-cross text-danger" />
                                                    )
                                                }
                                            </div>
                                            <div className="ContentGenLabel">
                                                <strong>{item.orderNumber}</strong> - orderID: #{item.barcodeNumber}
                                                {itemLoading === item._id &&
                                                    <i className='icon-spinner2 spinner ml-2' />}
                                                {this._showMessage(itemError, itemsSuccess, item._id)}
                                            </div>
                                        </div>
                                    )
                                })
                            )}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className='justify-content-between'>
                    {!startGen ? (
                        <div className="d-sm-flex align-items-center justify-content-between w-100">
                            {adminPermission &&
                                <Checkbox checked={force} onChange={this._handleChangeCheckBox} style={{ minWidth: '77px' }}>Force</Checkbox>
                            }
                            <div className="d-sm-flex justify-content-end w-100">
                                <Button onClick={handleToggleModal} className="bg-grey ml-2">
                                    Cancel
                                </Button>
                                <Button onClick={this._handleSubmit} className="bg-primary ml-2" disabled={disableBtnChange}>
                                    Change shipping carrier
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className="d-sm-flex">
                            <Button disabled={itemLoading} onClick={handleToggleModal} className="bg-grey ml-2">
                                Close
                            </Button>
                        </div>
                    )}
                </ModalFooter>
            </Modal>
        )
    }

}

export default BulkChangeShippingCarrierModal